import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHandler} from '@angular/common/http';
import {Observable} from 'rxjs';
import {WorkflowDefinitionControllerService} from '../../../api/api/workflowDefinitionController.service';
import {Configuration} from '../../../api/configuration';
import {MyCheckFeatureProposal} from '../../../api/model/myCheckFeatureProposal';
import {MyCheckFeatureProposalRequest} from '../../../api/model/myCheckFeatureProposalRequest';
import {QuietHttpHandler} from '../../../services/check-run-schedule/check-run-schedule.api';

/**
 * Lässt chatBIC einen Vorschlag für eine Feature-Anfrage aus dem Chat erzeugen
 * (`POST /workflows/definitions/mycheck/feature-request/proposal`), über den generierten
 * {@link WorkflowDefinitionControllerService}.
 *
 * <p>Der Service bekommt einen eigenen `HttpClient`, dessen Anfragen der globale
 * `HttpErrorInterceptor` nicht meldet: Schlägt der Vorschlag fehl (402/403/422/502, Netz), zeigt das
 * Formular ein leeres Formular mit eigenem Hinweis. Eine zusätzliche globale Fehlermeldung wäre dort
 * falsch. Lade-Interceptor und Dedup laufen unverändert mit.
 *
 * <p>Die Basis-URL kommt aus der regulär injizierten Instanz (Muster `check-run-schedule.api.ts`).
 */
@Injectable({providedIn: 'root'})
export class FeatureProposalApi {
  private readonly client: WorkflowDefinitionControllerService;

  constructor() {
    const quietHttp = new HttpClient(new QuietHttpHandler(inject(HttpHandler)));
    const basePath: string = (inject(WorkflowDefinitionControllerService) as any).basePath;
    const configuration = inject(Configuration, {optional: true}) ?? undefined;
    this.client = new WorkflowDefinitionControllerService(quietHttp, basePath, configuration as Configuration);
  }

  propose(projectId: number, request: MyCheckFeatureProposalRequest): Observable<MyCheckFeatureProposal> {
    return this.client.proposeMyCheckFeatureRequest(request, projectId);
  }
}
